/** Iraq phone helpers: +964750… ↔ 0750… */

export function digitsOnly(value) {
  return String(value ?? "").replace(/\D+/g, "");
}

/** Preferred login/display form: 07xxxxxxxxx */
export function canonicalIraqPhone(value) {
  const digits = digitsOnly(value);
  if (!digits) return String(value ?? "").replace(/\s+/g, "");
  if (digits.startsWith("964") && digits.length >= 12) {
    return `0${digits.slice(3)}`;
  }
  if (!digits.startsWith("0") && digits.length >= 9 && digits.length <= 10) {
    return `0${digits}`;
  }
  return digits;
}

/** Build login payload: email if it looks like one, otherwise phone. */
export function buildLoginPayload(identifier, password) {
  const raw = String(identifier ?? "").trim();
  const pwd = String(password ?? "");
  if (raw.includes("@")) {
    return { email: raw.toLowerCase(), password: pwd };
  }
  // Send local 07… when user typed +964… so login matches either stored form.
  const phone = canonicalIraqPhone(raw.replace(/\s+/g, ""));
  return { phone, password: pwd };
}

/** True if value is a usable email or phone for login. */
export function isLoginIdentifier(value) {
  const v = String(value ?? "").trim();
  if (!v) return false;
  if (v.includes("@")) {
    // Simple email shape check (backend validates fully).
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }
  return /^[+]?[\d\s()-]{7,20}$/.test(v);
}
